import moment from "moment";
import * as Yup from "yup";

export const formInformation = Yup.object().shape({
	formName: Yup.string().required("Required"),
	
	formDetails: Yup.object().shape({
		actionButtonLabel: Yup.string()
      .trim()
      .required("Required")
      .max(20, "Maximum 20 characters allowed"),
		contactInfo: Yup.object().shape({
			firstName: Yup.string().required("Required"),
			lastName: Yup.string().required("Required"),
			email: Yup.string().email("Invalid email").required("Required"),
		}),
    infiniteCapacity: Yup.boolean(),
    maximumCapacity: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : Number(originalValue)
      )
      .when('infiniteCapacity', {
        is: false,
        then: (schema) =>
          schema.typeError("Required").required("Required").positive("Must be greater than 0"),
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
	}),
   formStartDate: Yup.date()
    .nullable()
    .required("Required"),

  formEndDate: Yup.date()
    .nullable()
    .when("alwaysAvailable", {
      is: false,
      then: (schema) =>
        schema
          .required("Required")
          .min(
            Yup.ref("formStartDate"),
            "End date must be after start date"
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  alwaysAvailable: Yup.boolean(),

// 	prices: Yup.array().of(
//   Yup.object().shape({
//     amount: Yup.number()
//   .transform((value, originalValue) =>
//     originalValue === "" ? undefined : Number(originalValue)
//   )
//   .typeError("Amount is required")
//   .required("Amount is required"),

//     ledger: Yup.object()
//       .required("Ledger is required")
//       .test(
//         "not-empty",
//         "Ledger is required",
//         (value) => value && Object.keys(value).length > 0
//       ),
//   })
// )
// prices: Yup.array().of(
//   Yup.object().shape({
//   amount: Yup.number()
//   .transform((value, originalValue) =>
//     originalValue === "" ? undefined : Number(originalValue)
//   )
//   .when("type", {
//     is: (type) =>
//       type !== "No Payment Needed" && type !== "Open Amount",
//     then: (schema) =>
//       schema
//         .typeError("Amount is required")
//         .required("Amount is required")
//         .min(5, "Amount must be greater than or equal to 0"),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//     ledger: Yup.object()
//       .required("Ledger is required")
//       .test(
//         "not-empty",
//         "Ledger is required",
//         (value) => value && Object.keys(value).length > 0
//       ),
//   })
// )
});
